export default function Preloader() {
  return (
    <div className="loading-screen">
      <div className="lds-spinner">
        { 
          [...new Array(12)].map((_el, _index) => (<div key={`LoadingAnimationItem${_index}`} />))  
        }
      </div> 
    </div>
  )
}